import type { ButtonConfig, PreviewConfig } from '../types/exportConfig.types';

// Reusable preview config for integration options.
export const integrationPreview: PreviewConfig = {
  type: 'integration'
};

export const integrationButtons: ButtonConfig[] = [
  {
    label: 'Enable Access',
    action: 'export'
  }
];
